import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  year: number;       // PR_POST_YY (e.g. 2026)
  month: string;      // PR_POST_MM ("01"~"12")
  deptFrom: string;   // 部門代號篩選起始
  deptTo: string;     // 部門代號篩選終止
  deptLevel: number;  // 部門分級 1~4
  company: number;    // 公司別 1~3
}

export interface SalaryColumn {
  code: string;       // Item code (e.g. "1001", "1ADD")
  name: string;       // Item name
  isSpecial: boolean; // true for 1ADD/1PRN/2SUB/2SUM/2TX
}

export interface EmployeeRow {
  empCode: string;
  empName: string;
  deptCode: string;
  deptName: string;
  items: number[];    // Amounts indexed by column position
}

export interface DeptGroup {
  deptCode: string;
  deptName: string;
  employees: EmployeeRow[];
  subtotals: number[];
}

export interface QueryResponse {
  yearMonth: string;
  columns: SalaryColumn[];
  deptGroups: DeptGroup[];
  grandTotals: number[];
  totalEmps: number;
}

export interface LookupResult {
  code: string;
  name: string;
}

export interface DefaultsResult {
  year: number;
  month: string;
}

// ============================================================
// API Client
// ============================================================

export const pw9339Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9339/query', req);
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/pw9339/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },

  async getDefaults(): Promise<DefaultsResult> {
    const res = await apiClient.get('/api/pw9339/defaults');
    return res.data;
  },
};
